import { render, staticRenderFns } from "./KontakteIcon.vue?vue&type=template&id=0f2bcafc&scoped=true&"
var script = {}
import style0 from "./KontakteIcon.vue?vue&type=style&index=0&id=0f2bcafc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2bcafc",
  null
  
)

export default component.exports